<template>
  <div class="PageList">
    <RecordPage
      v-for="page in pages"
      :key="page.id"
      :page="page" />
  </div>
</template>

<script>
import RecordPage from './RecordPage'

export default {
  components: {
    RecordPage,
  },
  props: {
    pages: Array,
  },
}
</script>

<style lang="scss">
.PageList {
}
</style>
